import { createApp } from 'vue'
import {mapLocalizationData} from '../../../common/vue/helper/LocalizationMapper'
import ImageContentPluginForm from "./Scalepriceeditor.vue";

document.addEventListener('DOMContentLoaded', () =>{
    let rootSelector = '.scale-price-editor';
    let nodes = document.querySelectorAll(rootSelector);

    for (let i=0; i<nodes.length;i++) {
        let node = nodes[i];
        let inputField = node.getElementsByTagName('INPUT')[0];

        let app = createApp(ImageContentPluginForm, {
                        inputName: inputField.getAttribute('name'),
                        inputId: inputField.getAttribute('id'),
                        inputValue: inputField.getAttribute('value'),
                        i18n: mapLocalizationData(inputField),
                    }
        );
        app.mount(node);
    }
});
